{
  "notifications": {
    "title": "Notificaciones",
    "markAllRead": "Marcar todo como leído",
    "viewAll": "Ver todas las notificaciones",
    "empty": "Sin notificaciones",
    "emptyDescription": "¡Estás al día!",
    "new": "nueva",
    "today": "Hoy",
    "yesterday": "Ayer",
    "earlier": "Anteriores",
    "justNow": "Ahora mismo",
    "minutesAgo": "Hace {{count}} minuto",
    "minutesAgo_plural": "Hace {{count}} minutos",
    "hoursAgo": "Hace {{count}} hora",
    "hoursAgo_plural": "Hace {{count}} horas",
    "daysAgo": "Hace {{count}} día",
    "daysAgo_plural": "Hace {{count}} días",
    "categories": {
      "status_change": "Actualización de Estado",
      "correspondence": "Correspondencia",
      "deadline": "Fecha Límite",
      "approval_needed": "Aprobación Necesaria",
      "filing_complete": "Registro Completo",
      "new_filing": "Nuevo Registro",
      "office_action": "Acción de Oficina",
      "system": "Sistema"
    },
    "urgency": {
      "low": "Baja",
      "medium": "Media",
      "high": "Alta",
      "critical": "Crítica"
    },
    "actions": {
      "view": "Ver",
      "dismiss": "Descartar",
      "markRead": "Marcar como leído"
    }
  }
}
